import {lazy} from 'react';

const placeOrderRoutes = [
    {
        exact: true,
        path: '/place-order/select-asset',
        component: lazy(() => import('../views/PlaceOrderFlow/SelectAssetToRefuel')),
    },
    {
        exact: true,
        path: '/place-order/purchase-fuel',
        component: lazy(() => import('../views/PlaceOrderFlow/PurchaseFuel')),
    }
];

export default placeOrderRoutes;
